import { has, isEmpty } from "lodash";
import CrudEndpoint from "../lib/CrudEndpoint";

/*
 * Constantes con la url del server y de su api expuesta
 */
export const SERVER_URL = process.env.REACT_APP_API_BASE;

export const API_DEVICE = "/device";
export const API_PARKING = "/parking";
export const API_PARKING_CONTROL = "/parking_control";
export const API_PAYMENT = "/payment_method";
export const API_RATE = "/rate";
export const API_SECURITY = "/security";
export const API_USER = "/user";
export const API_VEHICLE = "/vehicle";
export const API_ZONE = "/zone";
export const API_ROL = "/rol";
export const API_PENALTY = "/parking_penalty";
export const API_PARAMETER = "/parameter";
export const API_STATS = "/stats/home";
export const API_PERMISSION = "/permission";

/*
 * Estructura de base para endpoints del proyecto
 */
const endpointConfiguration = {
  list: "{base}",
  add: "{base}",
  id: "{base}",
  edit: "{base}",
  delete: "{base}"
};

// clase para endpoints
export class Endpoint extends CrudEndpoint {
  constructor(api) {
    // {base} = SERVER_URL + api
    super(SERVER_URL + api, endpointConfiguration);
    this.api = api;
  }

  queryString(params) {
    // pager translatror "page=1&pageSize=10" => "from=0&size=10"
    if (has(params, "page") && has(params, "pageSize")) {
      const size = parseInt(params.pageSize, 10);
      const from = parseInt(params.page, 10) * size - size;
      params.from = from;
      params.size = size;
      delete params.page;
      delete params.pageSize;
    }
    if (has(params, "searchText") && isEmpty(params["searchText"])) {
      delete params.searchText;
    }
    return super.queryString(params);
  }
}



// WEBPACK FOOTER //
// ./src/provider/config/Endpoints.js